/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
import { GroupsResponseInterface, SavedViewDetailResponseInterface, SavedViewsResponseInterface } from "./SavedViewsInterfaces";

// #region Groups List
/**
 * Groups List Sample Data.
 */
export const groupsList: GroupsResponseInterface = {
  groups: [],
  _links: {
    self: {
      href: "",
    },
  },
};
// #endregion Groups List

// #region Saved View
/**
 * Saved View Sample Data mapped as SavedViewId and SavedViewResponseInterface.
 */
export const savedViewsDetailList: { [key: string]: SavedViewDetailResponseInterface } = {
  "": {
    savedView: {
      id: "",
      shared: true,
      savedViewData: {
        
      },
      displayName: "Blue Chairs",
      tags: [],
      _links: {
        creator: {
          href: "",
        },
        iTwin: {
          href: "",
        },
        imodel: {
          href: "",
        },
        image: {
          href: "",
        },
        thumbnail: {
          href: "",
        },
      },
    },
  }
};
// #endregion Saved View

// #region Saved Views List
/**
 * Saved Views List Sample Data
 */
export const savedViewsList: SavedViewsResponseInterface = {
  savedViews: [{
    id: "",
    shared: true,
    displayName: "Blue Chairs",
    tags: [],
    _links: {
      creator: {
        href: "",
      },
      iTwin: {
        href: "",
      },
      imodel: {
        href: "",
      },
      image: {
        href: "",
      },
      thumbnail: {
        href: "",
      },
    },
  }],
  _links: {
    self: {
      href: "",
    },
  },
};
// #endregion Saved Views List
